export const tools = [
  {
    slug: 'convertidor-markdown',
    name: 'Convertidor a Markdown',
    seoTitle: 'Convertidor a Markdown: PDF, Word, Excel y más',
    description: 'Convierte PDF, Word, Excel, PowerPoint, HTML y TXT a Markdown de forma rápida y segura.',
    seoDescription: 'Convierte PDF, Word, Excel, PowerPoint, HTML y TXT a Markdown gratis y en segundos. Ideal para documentación, wikis y prompts de IA.',
    shortDescription: 'Sube documentos y conviértelos a Markdown con controles de seguridad, CAPTCHA y límites de uso.',
    status: 'active',
    category: 'productividad',
    type: 'converter',
    featured: true,
    relatedSlugs: ['ahorro-automatizacion', 'consumo-electrico', 'convertidor-dados'],
    faq: [
      {
        question: '¿Se guarda el archivo que subo?',
        answer: 'No. En el plan gratuito el archivo se usa solo para la conversión y debe eliminarse después del procesamiento temporal.',
      },
      {
        question: '¿Qué formatos acepta el convertidor?',
        answer: 'Inicialmente acepta PDF, DOCX, XLSX, PPTX, TXT y HTML. Otros formatos se rechazan por seguridad.',
      },
    ],
  },
  {
    slug: 'calculadora-soldadura',
    name: 'Calculadora de soldadura SMAW',
    seoTitle: 'Calculadora de soldadura SMAW: amperaje y electrodo',
    description: 'Obtén recomendaciones de amperaje, polaridad y electrodo con inteligencia artificial.',
    seoDescription: 'Calcula el amperaje, la polaridad y el electrodo correctos para soldadura SMAW según el material y el espesor. Gratis y al instante.',
    shortDescription: 'Apoya ajustes rápidos de soldadura y configuraciones técnicas en campo o taller.',
    status: 'active',
    category: 'soldadura',
    type: 'calculator',
    featured: true,
    relatedSlugs: ['calculadora-generador', 'consumo-electrico', 'ahorro-automatizacion'],
    faq: [
      {
        question: '¿Esta calculadora sustituye una WPS o procedimiento formal?',
        answer: 'No. Es una referencia rápida y debe validarse con el procedimiento y materiales reales de trabajo.',
      },
    ],
  },
  {
    slug: 'convertidor-dados',
    name: 'Convertidor de pulgadas a mm para dados',
    seoTitle: 'Convertidor de pulgadas a mm para dados',
    description: 'Convierte medidas en pulgadas a milímetros para herramientas mecánicas.',
    seoDescription: 'Convierte medidas de dados y llaves de pulgadas a milímetros (1/2, 3/4, 9/16…) y encuentra la equivalencia exacta para tu herramienta.',
    shortDescription: 'Convierte equivalencias de dados y herramientas imperiales a milímetros.',
    status: 'active',
    category: 'mecánica',
    type: 'converter',
    featured: true,
    relatedSlugs: ['convertidor-torque', 'consumo-electrico', 'calculadora-generador'],
    faq: [
      {
        question: '¿Sirve para herramientas y dados automotrices?',
        answer: 'Sí. Está pensada para equivalencias rápidas entre medidas imperiales y métricas en trabajo técnico.',
      },
    ],
  },
  {
    slug: 'convertidor-tuberias',
    name: 'Convertidor de tuberías',
    seoTitle: 'Convertidor de tuberías: mm a pulgadas nominales',
    description: 'Convierte milímetros a pulgadas nominales para tuberías.',
    seoDescription: 'Convierte diámetros de tubería de milímetros a pulgadas nominales con su tabla de equivalencias. Gratis, al instante y sin registro.',
    shortDescription: 'Consulta equivalencias nominales para tuberías sin depender de conversiones manuales.',
    status: 'active',
    category: 'construcción',
    type: 'converter',
    relatedSlugs: ['convertidor-dados', 'calculadora-materiales', 'ahorro-automatizacion'],
    faq: [
      {
        question: '¿Las tuberías se convierten directo con fórmula?',
        answer: 'No siempre. En muchas aplicaciones se usan equivalencias nominales, no una conversión exacta del diámetro real.',
      },
    ],
  },
  {
    slug: 'convertidor-torque',
    name: 'Calculadora de torque',
    seoTitle: 'Calculadora de torque: convierte Nm a lb-ft',
    description: 'Convierte Nm a lb-ft y viceversa.',
    seoDescription: 'Convierte torque de Nm a lb-ft y de lb-ft a Nm al instante. Útil para apretar tornillos, ruedas y piezas de motor con la llave correcta.',
    shortDescription: 'Conversión rápida de torque para mantenimiento, mecánica e interpretación de manuales.',
    status: 'active',
    category: 'mecánica',
    type: 'converter',
    featured: true,
    relatedSlugs: ['convertidor-dados', 'calculadora-generador', 'ahorro-automatizacion'],
    faq: [
      {
        question: '¿Sirve para mantenimiento industrial y automotriz?',
        answer: 'Sí. Es útil para consultar especificaciones mezcladas en Nm y lb-ft durante ajustes o mantenimiento.',
      },
    ],
  },
  {
    slug: 'consumo-electrico',
    name: 'Calculadora de consumo eléctrico en México',
    seoTitle: 'Calculadora de consumo eléctrico en México',
    description: 'Calcula el costo de energía según watts y horas de uso.',
    seoDescription: 'Calcula cuántos kWh consume un aparato y cuánto pagas de luz según sus watts y horas de uso. Estima tu recibo de luz en México.',
    shortDescription: 'Estima kWh y costo mensual por equipo, proceso o área operativa.',
    status: 'active',
    category: 'eléctrico',
    type: 'calculator',
    featured: true,
    relatedSlugs: ['calculadora-generador', 'ahorro-automatizacion', 'convertidor-dados'],
    faq: [
      {
        question: '¿El costo por kWh siempre es igual?',
        answer: 'No. Puede variar por tarifa, región, horario y tipo de servicio, pero esta calculadora ayuda como estimación rápida.',
      },
    ],
  },
  {
    slug: 'calibre-cable',
    name: 'Calculadora de calibre de cable',
    seoTitle: 'Calculadora de calibre de cable eléctrico',
    description: 'Determina el calibre ideal de cable eléctrico según tu instalación.',
    seoDescription: 'Calcula el calibre AWG de cable eléctrico según amperaje, distancia y caída de tensión. Elige el cable correcto para tu instalación.',
    shortDescription: 'Apoya decisiones preliminares para selección de calibre en instalaciones eléctricas.',
    status: 'active',
    category: 'eléctrico',
    type: 'calculator',
    relatedSlugs: ['consumo-electrico', 'calculadora-generador', 'ahorro-automatizacion'],
    faq: [
      {
        question: '¿Sustituye un diseño eléctrico completo?',
        answer: 'No. Sirve como apoyo rápido, pero la selección final debe validar normativa, distancia, carga y condiciones reales.',
      },
    ],
  },
  {
    slug: 'calculadora-materiales',
    name: 'Calculadora de materiales de construcción',
    seoTitle: 'Calculadora de materiales de construcción por área',
    description: 'Calcula bultos de cemento, arena, grava y piezas necesarias por m².',
    seoDescription: 'Calcula cuántos bultos de cemento, arena, grava y piezas de block necesitas por m² para tu obra. Presupuesta tu construcción gratis.',
    shortDescription: 'Ayuda a estimar materiales y evitar cálculos manuales repetitivos en obra.',
    status: 'active',
    category: 'construcción',
    type: 'calculator',
    relatedSlugs: ['convertidor-tuberias', 'ahorro-automatizacion', 'consumo-electrico'],
    faq: [
      {
        question: '¿La calculadora funciona para cualquier obra?',
        answer: 'Sirve como aproximación inicial y debe ajustarse según especificaciones del proyecto, desperdicio y sistema constructivo.',
      },
    ],
  },
  {
    slug: 'calculadora-generador',
    name: 'Calculadora de generador eléctrico',
    seoTitle: 'Calculadora de generador eléctrico: ¿qué generador necesito?',
    description: 'Calcula la potencia de generador necesaria para tus equipos.',
    seoDescription: 'Calcula la potencia en watts del generador eléctrico que necesitas según tus equipos y el tipo de carga. Evita comprar uno pequeño o de más.',
    shortDescription: 'Dimensiona generadores para cargas eléctricas, talleres, obra y respaldo operativo.',
    status: 'active',
    category: 'eléctrico',
    type: 'calculator',
    featured: true,
    relatedSlugs: ['consumo-electrico', 'ahorro-automatizacion', 'convertidor-torque'],
    faq: [
      {
        question: '¿Conviene dejar margen sobre la potencia calculada?',
        answer: 'Sí. Un margen ayuda a cubrir picos de arranque, crecimiento y una operación más estable del generador.',
      },
    ],
  },
  {
    slug: 'ahorro-automatizacion',
    name: 'Calculadora de ahorro por automatización',
    seoTitle: 'Calculadora de ahorro por automatización de procesos',
    description: 'Estima cuánto tiempo y dinero pierde tu empresa por tareas manuales repetitivas.',
    seoDescription: 'Estima cuántas horas y cuánto dinero pierde tu empresa en tareas manuales repetitivas y cuánto ahorrarías al automatizarlas.',
    shortDescription: 'Calcula horas y costo recuperable al automatizar reportes, capturas y procesos manuales.',
    status: 'active',
    category: 'negocio',
    type: 'calculator',
    featured: true,
    relatedSlugs: ['consumo-electrico', 'calculadora-generador', 'convertidor-torque'],
    faq: [
      {
        question: '¿Solo aplica para Excel?',
        answer: 'No. También aplica a procesos repetitivos con correos, reportes, capturas y consolidación manual de información.',
      },
    ],
  },
];

export const pipeTable = [
  { mm: 6, pulgadas: '1/8"' },
  { mm: 8, pulgadas: '1/4"' },
  { mm: 10, pulgadas: '3/8"' },
  { mm: 15, pulgadas: '1/2"' },
  { mm: 20, pulgadas: '3/4"' },
  { mm: 25, pulgadas: '1"' },
  { mm: 32, pulgadas: '1 1/4"' },
  { mm: 40, pulgadas: '1 1/2"' },
  { mm: 50, pulgadas: '2"' },
  { mm: 65, pulgadas: '2 1/2"' },
  { mm: 80, pulgadas: '3"' },
  { mm: 90, pulgadas: '3 1/2"' },
  { mm: 100, pulgadas: '4"' },
  { mm: 125, pulgadas: '5"' },
  { mm: 150, pulgadas: '6"' },
  { mm: 200, pulgadas: '8"' },
  { mm: 250, pulgadas: '10"' },
  { mm: 300, pulgadas: '12"' },
];
